import { Typography } from "antd";
import { useStyles } from "../personInfoModal";
import { VerticalSpace } from "@app/UI/VerticalSpace";
import { CEOBlock } from "./CEOBlock";
import { FounderBlock } from "./founderBlock";
import { BeneficiaryBlock } from "./beneficiaryBlock";
import { MembersBlock } from "./membersBlock";

const { Title } = Typography;

export const PersonRoles = ({ control, setValue, readonly, register, personW }) => {
  const classes = useStyles();

  return (
    <div className={classes.rolesWrapper}>
      <Title level={4}>Роли физ.лица в компании</Title>
      <VerticalSpace>
        <CEOBlock
          control={control}
          setValue={setValue}
          readonly={readonly}
          register={register}
          personW={personW}
        />
        <FounderBlock
          control={control}
          setValue={setValue}
          readonly={readonly}
          register={register}
          personW={personW}
        />
        <BeneficiaryBlock
          control={control}
          setValue={setValue}
          readonly={readonly}
          register={register}
          personW={personW}
        />
        <MembersBlock register={register} personW={personW} setValue={setValue} />
      </VerticalSpace>
    </div>
  );
};
